<template>
    <section class="pt-2" style="height:calc(100vh - 146px)">
        <div class="row mx-0 h-100">
            <div class="menu-prinicipal h-100 br-tl-8">
                <div class="row mx-0 align-items-center border-b-gris border-r-gris" style="height:56px;">
                    <div class="col-12 my-auto">
                        <el-input v-model="buscar" size="small" clearable placeholder="Buscar pedido - cliente - direccion" class="br-20" />
                    </div>
                </div>
                <div class="col px-0 overflow-auto custom-scroll border-r-gris " style="width:400px;height:calc(100% - 53px);">
                    <div>
                        <div class="row mx-3 my-2 p-2 px-3 br-10 border bg-whitesmoke justify-content-between">
                            <span>Sin confirmar</span>
                            <div class="d-middle">
                                <div class="br-20 bg-white f-600 px-2">
                                    {{ fill_sin_confirmar.length }}
                                </div>
                                <i class="cr-pointer ml-2 f-18" :class="ver_sinconfirmar ? 'icon-angle-down' : 'icon-angle-up'" @click="ver_sinconfirmar = !ver_sinconfirmar" />
                            </div>
                        </div>
                        <div
                        v-for="(sc, idx) in fill_sin_confirmar" :key="idx"
                        class="row mx-0 pr-2 d-middle cr-pointer my-2 border-bottom pb-2"
                        :class="{'d-none':ver_sinconfirmar}"
                        @click="seleccionar_pedido(sc.id)"
                        >
                            <div :class="`mx-2 px-1 br-5 ${activo==sc.id?'bg-general':''}`" style="height:90px;" />
                            <div :class="`col-11 px-0 tres-puntos py-2 f-15 br-10 ${activo==sc.id?'bg-light-f5':''}`">
                                <div class="row mx-0 px-3 align-items-center justify-content-around">
                                    <div v-show="sc.id_pedido" class="icono text-dark">
                                        <i class="icon-account-plus" />
                                    </div>
                                    <div class="col-4 px-2 d-middle">
                                        <p class="tres-puntos f-600 text-dark">ID. {{ sc.id }}</p>
                                    </div>
                                    <div class="col-4 px-1 f-600 text-dark" :class="{'col-6':sc.cant_mensajes == 0}" style="text-align: end;">
                                        {{ convertMoney(sc.valor_final,sc.idm_moneda) }}
                                    </div>
                                    <div v-if="sc.cant_mensajes > 0" class="pt-2 col pr-0">
                                        <el-badge :value="sc.cant_mensajes" class="item ml-3">
                                            <i class="icon-message-text-outline cr-pointer f-20 text-gr-general" />
                                        </el-badge>
                                    </div>
                                </div>
                                <div class="row mx-0 px-3 my-1 text-general f-15">
                                    <div class="col-8 px-2">
                                        <p class="tres-puntos">{{ sc.fecha_entrega | helper-fecha('DD MMM hh:mm a') }}</p>
                                    </div>
                                    <div class="col-4 px-1">
                                        <b class="mr-1">
                                            {{ sc.cant_productos }}
                                        </b>
                                        Productos
                                    </div>
                                </div>
                                <div class="row px-3 mx-0 f-15">
                                    <div class="col px-2 d-middle">
                                        <i class="icon-location text-gris f-14" />
                                        <p class="tres-puntos">{{ sc.direccion }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="row mx-3 p-2 px-3 br-10 border bg-whitesmoke justify-content-between">
                            <span>Confirmados</span>
                            <div class="d-middle">
                                <div class="br-20 bg-white f-600 px-2">
                                    {{ fill_confirmados.length }}
                                </div>
                                <i class="cr-pointer ml-2 f-18" :class="ver_confirmados ? 'icon-angle-down' : 'icon-angle-up'" @click="ver_confirmados = !ver_confirmados" />
                            </div>
                        </div>
                        <div
                        v-for="(c, idx) in fill_confirmados" :key="idx"
                        class="row mx-0 pr-2 d-middle cr-pointer my-2 border-bottom pb-2"
                        :class="{'d-none':ver_confirmados}"
                        @click="seleccionar_pedido(c.id)"
                        >
                            <div :class="`mx-2 px-1 br-5 ${activo==c.id?'bg-general':''}`" style="height:90px;" />
                            <div
                            class="col-11 px-0 tres-puntos py-2 f-15 br-10"
                            :class="`${activo==c.id?'bg-light-f5':''}`"
                            >
                                <div class="row mx-0 px-3 align-items-center justify-content-around">
                                    <div v-if="c.manual === 1" class="icono text-danger">
                                        <i class="icon-warehouse" />
                                    </div>
                                    <div v-if="c.id_pedido" class="icono text-dark">
                                        <i class="icon-account-plus" />
                                    </div>
                                    <div class="col-4 px-2 d-middle">
                                        <p class="tres-puntos f-600 text-dark">ID. {{ c.id }}</p>
                                    </div>
                                    <div class="col-4 px-1 f-600 text-dark" :class="{'col-6':c.cant_mensajes == 0}" style="text-align: end;">
                                        {{ convertMoney(c.valor_final,c.idm_moneda) }}
                                    </div>
                                    <div v-if="c.cant_mensajes > 0" class="pt-2">
                                        <el-badge :value="c.cant_mensajes" class="item mx-2 mr-4">
                                            <i class="icon-message-text-outline cr-pointer f-20 text-gr-general" />
                                        </el-badge>
                                    </div>
                                </div>
                                <div class="row mx-0 px-3 my-1 text-general f-15">
                                    <div class="col-8 px-0">
                                        <p class="tres-puntos">{{ c.fecha_entrega | helper-fecha('DD MMM hh:mm a') }}</p>
                                    </div>
                                    <div class="col-4 px-0 text-right">
                                        <b class="mr-1">
                                            {{ c.cant_productos }}
                                        </b>
                                        Productos
                                    </div>
                                </div>
                                <div class="row px-3 mx-0 f-15">
                                    <div class="col px-0 d-middle">
                                        <i class="icon-location text-general f-20" />
                                        <p class="tres-puntos text-general">{{ c.direccion }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="row m-3 p-2 px-3 br-10 border bg-whitesmoke justify-content-between">
                            <span>En Alistamento</span>
                            <div class="d-middle">
                                <div class="br-20 bg-white f-600 px-2">
                                    {{ fill_alistados.length }}
                                </div>
                                <i class="cr-pointer ml-2 f-18" :class="ver_alistados ? 'icon-angle-down' : 'icon-angle-up'" @click="ver_alistados = !ver_alistados" />
                            </div>
                        </div>
                        <div
                        v-for="(c, idx) in fill_alistados" :key="idx"
                        class="row mx-0 pr-2 d-middle cr-pointer my-2 border-bottom pb-2"
                        :class="{'d-none':ver_alistados}"
                        @click="seleccionar_pedido(c.id)"
                        >
                            <div :class="`mx-2 px-1 br-5 ${activo==c.id?'bg-general':''}`" style="height:90px;" />
                            <div
                            class="col-11 px-0 tres-puntos py-2 f-15 br-10"
                            :class="`${activo==c.id?'bg-light-f5':''}`"
                            >
                                <div class="row mx-0 d-middle justify-content-around">
                                    <div v-show="c.manual === 1" class="icono text-danger">
                                        <i class="icon-warehouse" />
                                    </div>
                                    <div v-show="c.id_pedido" class="icono text-dark">
                                        <i class="icon-account-plus" />
                                    </div>
                                    <div class="col-4 px-2 d-middle">
                                        <p class="tres-puntos f-600 text-dark">ID. {{ c.id }}</p>
                                    </div>
                                    <div class="col-4 px-1 f-600 text-dark" :class="{'col-6':c.cant_mensajes == 0}" style="text-align: end;">
                                        {{ convertMoney(c.valor_final,c.idm_moneda) }}
                                    </div>
                                    <div v-if="c.cant_mensajes > 0" class="pt-2">
                                        <el-badge :value="c.cant_mensajes" class="item mx-2 mr-4">
                                            <i class="icon-message-text-outline cr-pointer f-20 text-gr-general" />
                                        </el-badge>
                                    </div>
                                </div>
                                <div class="row px-3 mx-0 my-1">
                                    <div class="col-8 px-2">
                                        <p class="tres-puntos">{{ c.fecha_entrega | helper-fecha('DD MMM hh:mm a') }}</p>
                                    </div>
                                    <div class="col-4 px-1">
                                        <b class="mr-1">
                                            {{ c.cant_productos }}
                                        </b>
                                        Productos
                                    </div>
                                </div>
                                <div class="row px-3 mx-0 f-15">
                                    <div class="col px-0 d-middle">
                                        <i class="icon-location text-general f-20" />
                                        <p class="tres-puntos">{{ c.direccion }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="row m-3 p-2 px-3 br-10 border bg-whitesmoke justify-content-between">
                            <span>Empacados</span>
                            <div class="d-middle">
                                <div class="br-20 bg-white f-600 px-2">
                                    {{ fill_empacados.length }}
                                </div>
                                <i class="cr-pointer ml-2 f-18" :class="ver_empacados ? 'icon-angle-down' : 'icon-angle-up'" @click="ver_empacados = !ver_empacados" />
                            </div>
                        </div>
                        <div
                        v-for="(c, idx) in fill_empacados" :key="idx"
                        class="row mx-0 pr-2 d-middle cr-pointer my-2 border-bottom pb-2"
                        :class="{'d-none':ver_empacados}"
                        @click="seleccionar_pedido(c.id)"
                        >
                            <div :class="`mx-2 px-1 br-5 ${activo==c.id?'bg-general':''}`" style="height:90px;" />
                            <div
                            class="col-11 px-0 tres-puntos py-2 f-15 br-10"
                            :class="`${activo==c.id?'bg-light-f5':''}`"
                            >
                                <div class="row mx-0 d-middle justify-content-around">
                                    <div v-show="c.manual === 1" class="icono text-danger">
                                        <i class="icon-warehouse" />
                                    </div>
                                    <div v-show="c.id_pedido" class="icono text-dark">
                                        <i class="icon-account-plus" />
                                    </div>
                                    <div class="col-4 px-2 d-middle">
                                        <p class="tres-puntos text-dark f-600">ID. {{ c.id }}</p>
                                    </div>
                                    <div class="col-4 px-1 f-600 text-dark" :class="{'col-6':c.cant_mensajes == 0}" style="text-align: end;">
                                        {{ convertMoney(c.valor_final,c.idm_moneda) }}
                                    </div>
                                    <div v-if="c.cant_mensajes > 0" class="pt-2">
                                        <el-badge :value="c.cant_mensajes" class="item mx-2 mr-4">
                                            <i class="icon-message-text-outline cr-pointer f-20 text-gr-general" />
                                        </el-badge>
                                    </div>
                                </div>
                                <div class="row px-3 mx-0 my-1">
                                    <div class="col-8 px-2">
                                        <p class="tres-puntos">{{ c.fecha_entrega | helper-fecha('DD MMM hh:mm a') }}</p>
                                    </div>
                                    <div class="col-4 px-1">
                                        <b class="mr-1">
                                            {{ c.cant_productos }}
                                        </b>
                                        Productos
                                    </div>
                                </div>
                                <div class="row px-3 mx-0">
                                    <div class="col-12 px-2 d-middle">
                                        <i class="icon-location text-gris f-14" />
                                        <p class="tres-puntos">{{ c.direccion }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="row m-3 p-2 px-3 br-10 border bg-whitesmoke justify-content-between">
                            <span>Enviados</span>
                            <div class="d-middle">
                                <div class="br-20 bg-white f-600 px-2">
                                    {{ fill_enviados.length }}
                                </div>
                                <i class="cr-pointer ml-2 f-18" :class="ver_enviados ? 'icon-angle-down' : 'icon-angle-up'" @click="ver_enviados = !ver_enviados" />
                            </div>
                        </div>
                        <div
                        v-for="(e, idx) in fill_enviados" :key="idx"
                        class="row mx-0 pr-2 d-middle cr-pointer my-2 border-bottom pb-2"
                        :class="{'d-none': ver_enviados}"
                        @click="seleccionar_pedido(e.id)"
                        >
                            <div :class="`mx-2 px-1 br-5 ${activo==e.id?'bg-general':''}`" style="height:75px;" />
                            <div
                            class="col-11 px-0 tres-puntos py-2 f-15 br-10"
                            :class="`${activo==e.id?'bg-light-f5':''}`"
                            >
                                <div class="row mx-0 d-middle justify-content-around">
                                    <div v-show="e.manual === 1" class="icono text-danger">
                                        <i class="icon-warehouse" />
                                    </div>
                                    <div v-show="e.id_pedido" class="icono text-dark">
                                        <i class="icon-account-plus" />
                                    </div>
                                    <div class="col-4 px-2 pl-4 d-middle">
                                        <p class="tres-puntos f-600 text-dark">ID. {{ e.id }}</p>
                                    </div>
                                    <div class="col-4 px-1 f-600 text-dark" :class="{'col-6':e.cant_mensajes == 0}" style="text-align: end;">
                                        {{ convertMoney(e.valor_final,e.idm_moneda) }}
                                    </div>
                                    <div v-if="e.cant_mensajes > 0" class="pt-2">
                                        <el-badge :value="e.cant_mensajes" class="item mx-2 mr-4">
                                            <i class="icon-message-text-outline cr-pointer f-20 text-gr-general" />
                                        </el-badge>
                                    </div>
                                </div>
                                <div class="row px-3 mx-0 my-1">
                                    <div class="col-8 px-2">
                                        <p class="tres-puntos">{{ e.fecha_entrega | helper-fecha('DD MMM hh:mm a') }}</p>
                                    </div>
                                    <div class="col-4 px-1">
                                        <b class="mr-1">
                                            {{ e.cant_productos }}
                                        </b>
                                        Productos
                                    </div>
                                </div>
                                <div class="row px-3 mx-0">
                                    <div class="col-12 px-2 d-middle">
                                        <i class="icon-location text-gris f-14" />
                                        <p class="tres-puntos">{{ e.direccion }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="sin_confirmar.length === 0 && confirmados.length === 0 && enviados.length === 0 && alistados.length === 0 && empacados.length === 0" class="row mx-0 mt-4 align-items-center justify-content-center">
                        <div class="text-center f-15 f-600 d-middle-center flex-column" style="width:225px;">
                            <div class="d-middle-center bg-whitesmoke br-5" style="width:115px;height:115px;">
                                <img height="110" src="/img/no-imagen/canasta.svg" alt="" />
                            </div>
                            <p>Esperamos que estés preparado ¡Ya vienen los pedidos!</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="px-0 col menu-prinicipal h-100 br-tr-8" style="width: calc(100vw - 560px);">
                <ver-chat-vigentes v-show="id_pedido!== null" @actualizar="listarChatsVigentes" />
            </div>
        </div>
        <!-- <modal-crear-pedido ref="modalCrearPedido" />
        <filtro-pedidos ref="modalFiltro" :opcion="1" @filtrar="accion_filtro" /> -->
    </section>
</template>

<script>
import {mapGetters} from 'vuex'
import Pedidos from '~/services/pedidos/pedidos-admin'
import Chat from '~/services/chat/chat'
import moment from 'moment'
export default {
    sockets: {
        pedidos(obj){
            //console.log(obj);
            this.verificar_pedido(obj)
        },
        admin_pedidos_chats(value){ // Emite Cuando se escribe en tabla admin_pedidos_chats
            try {
                const {chat, pedidoChat} = JSON.parse(value)
                // console.log(this.$route.name);
                if(this.$route.name=== 'admin.almacen.pedidos'){// Si el mensaje es de un pedido del admin logueado
                    // console.log(parseInt(this.$route.params.id_pedido), parseInt(chat.id_admin_pedido), (this.$route.params.id_pedido !== parseInt(chat.id_admin_pedido)));
                    if( parseInt(this.$route.params.id_pedido) !== parseInt(chat.id_admin_pedido)){// cuando No tengo abierto  el chat del pedido actual entonces notifico
                        let idx_confirmado = this.confirmados.findIndex(e => e.id == pedidoChat.id)
                        let idx_enviado= this.enviados.findIndex(e => e.id == pedidoChat.id)
                        let idx_sin_confirmar= this.sin_confirmar.findIndex(e => e.id == pedidoChat.id)
                        let idx_alistados= this.alistados.findIndex(e => e.id == pedidoChat.id)
                        let idx_empacados= this.empacados.findIndex(e => e.id == pedidoChat.id)
                        if(idx_confirmado >= 0){
                            let found = this.confirmados[idx_confirmado]
                            found.cant_mensajes = found.cant_mensajes +1
                        }else if(idx_enviado >= 0){
                            let found = this.enviados[idx_enviado]
                            found.cant_mensajes = found.cant_mensajes +1
                        }else if(idx_sin_confirmar >= 0){
                            let found = this.sin_confirmar[idx_sin_confirmar]
                            found.cant_mensajes = found.cant_mensajes +1
                        }else if(idx_alistados >= 0){
                            let found = this.alistados[idx_alistados]
                            found.cant_mensajes = found.cant_mensajes +1
                        }else if(idx_empacados >= 0){
                            let found = this.empacados[idx_empacados]
                            found.cant_mensajes = found.cant_mensajes +1
                        }
                        if(this.pedido && this.pedido.id == chat.id_admin_pedido){
                            this.pedido.cant_mensajes = this.pedido.cant_mensajes + 1
                        }
                    }
                }

            } catch (e){
                this.error_catch(e)
            }
        }
    },
    middleware:['auth'],
    metaInfo: () =>({ title: 'Pedidos'}),
    components: {
        VerChatVigentes: () => import('./verChatVigentes.vue'),
    },
    data(){
        return {
            buscar: '',
            activo: -1,
            ver_sinconfirmar:false,
            ver_confirmados:true,
            ver_alistados:true,
            ver_empacados:true,
            ver_enviados:true,
        }
    },
    computed:{
        ...mapGetters({
            indicadores: 'pedidos/pedidos_admin/indicadores',
            sin_confirmar: 'pedidos/pedidos_admin/sin_confirmar',
            confirmados: 'pedidos/pedidos_admin/confirmados',
            alistados: 'pedidos/pedidos_admin/alistados',
            empacados: 'pedidos/pedidos_admin/empacados',
            enviados: 'pedidos/pedidos_admin/enviados',
            pedido: 'pedidos/pedidos_admin/pedido', // solo para actualizar icono chat
            id_pedido: 'pedidos/pedidos_admin/id_pedido',
            id_cedis:'cedis/id_cedis'
        }),
        rol(){
            return this.$usuario.rol_nombre
        },
        fill_sin_confirmar(){
            if(this.buscar !== null && this.buscar !== ''){
                return this.sin_confirmar.filter(el =>
                    String(el.id).includes(this.buscar.toLowerCase()) ||
                    el.nombre.toLowerCase().includes(this.buscar.toLowerCase()) ||
                    String(el.direccion).toLowerCase().includes(this.buscar.toLowerCase())
                )
            }else{
                return this.sin_confirmar
            }
        },
        fill_confirmados(){
            if(this.buscar !== null && this.buscar !== ''){
                return this.confirmados.filter(el =>
                    String(el.id).includes(this.buscar.toLowerCase()) ||
                    el.nombre.toLowerCase().includes(this.buscar.toLowerCase()) ||
                    String(el.direccion).toLowerCase().includes(this.buscar.toLowerCase())
                )
            }else{
                return this.confirmados
            }
        },
        fill_alistados(){
            if(this.buscar !== null && this.buscar !== ''){
                return this.alistados.filter(el =>
                    String(el.id).includes(this.buscar.toLowerCase()) ||
                    el.nombre.toLowerCase().includes(this.buscar.toLowerCase()) ||
                    String(el.direccion).toLowerCase().includes(this.buscar.toLowerCase())
                )
            }else{
                return this.alistados
            }
        },
        fill_empacados(){
            if(this.buscar !== null && this.buscar !== ''){
                return this.empacados.filter(el =>
                    String(el.id).includes(this.buscar.toLowerCase()) ||
                    el.nombre.toLowerCase().includes(this.buscar.toLowerCase()) ||
                    String(el.direccion).toLowerCase().includes(this.buscar.toLowerCase())
                )
            }else{
                return this.empacados
            }
        },
        fill_enviados(){
            if(this.buscar !== null && this.buscar !== ''){
                return this.enviados.filter(el =>
                    String(el.id).includes(this.buscar.toLowerCase()) ||
                    el.nombre.toLowerCase().includes(this.buscar.toLowerCase()) ||
                    String(el.direccion).toLowerCase().includes(this.buscar.toLowerCase())
                )
            }else{
                return this.enviados
            }
        },
    },
    watch:{
        // async id_pedido(val){
        //     if(val){
        //         //console.log('aca22222222222');
        //         // this.sincronizar()
        //         // await this.$store.dispatch('pedidos/pedidos_admin/ver_pedido', Number(val))

        //         // await this.validar_estado_pedido(Number(this.id_pedido))
        //         // this.$store.commit('pedidos/pedidos_admin/set_id_pedido', Number(this.id_pedido))
        //         await this.$store.dispatch('pedidos/pedidos_admin/pedidos_productos', Number(this.id_pedido))
        //         this.$store.dispatch('pedidos/pedidos_admin/pedidos_historial', Number(this.id_pedido))
        //         this.$store.dispatch('pedidos/pedidos_admin/pedidos_resumenes', Number(this.id_pedido))
        //         if(this.pedido.pago_estado === 2){
        //             this.$store.dispatch('pedidos/pedidos_admin/pedido_credito', this.id_pedido)
        //         }
        //         this.activo = this.id_pedido
        //     }
        // },
        id_cedis(val,oldVal){
            if(val != null){
                if(oldVal == null) return
                this.$store.dispatch('pedidos/pedidos_admin/listarChatsVigentes',val)
                // this.lista_indicadores()
                this.$store.commit('pedidos/pedidos_admin/set_id_pedido', null)
                this.activo = -1
            }
        }
    },
    mounted(){
        this.sincronizar()
    },
    methods: {
        async sincronizar(){
            //console.log('mounted');
            let that = this
            if(this.id_cedis === null){
                setTimeout(function(){
                    // that.lista_indicadores()
                    that.listarChatsVigentes()
                }, 500);
            }else{
                // that.lista_indicadores()
                that.listarChatsVigentes()
            }
        },
        verificar_pedido(item){
            const {id,tipo,data} = JSON.parse(item)

            if(data.id_user === this.$usuario.id){
                if(tipo === 332){
                    if(id == this.id_pedido){
                        this.$route.params.id_pedido = null
                        this.$router.push({name:'admin.almacen.pedidos'})
                        this.sincronizar()
                    }
                }else if(tipo === 331){
                    // this.lista_indicadores()
                    this.listarChatsVigentes()
                }else if(tipo === 0){
                    this.listarChatsVigentes()
                    this.sincronizar()
                }
            }
        },
        async validar_estado_pedido(id){
            const {data} = await Pedidos.validar_estado(id)
            if([1,2,201,202,3,31].indexOf(data.estado) < 0){
                this.$router.push({name:'admin.almacen.historial'})
            }
        },
        async listarChatsVigentes(){
            try {

                this.$store.dispatch('pedidos/pedidos_admin/listarChatsVigentes',this.id_cedis)
            } catch (e){
                this.error_catch(e)
            }
        },
        async seleccionar_pedido(id){
            this.activo = id
            // await this.actualizarUltimaLecturaChat()
            this.$store.commit('pedidos/pedidos_admin/set_id_pedido', id)
            await this.listarChatsVigentes()
        },
        tiempo(fecha){
            return moment(fecha).fromNow()
        },
    }
}
</script>

<style lang="scss" scoped>
.menu-prinicipal{
    background: #fff;
}
.bg-blue{
    background: #0D4DFF;
}
.icono{
    /* padding-left: 5px;
    padding-right: 5px; */
    i{
        font-size: 20px;
        position: relative;
    }
}
</style>
